import { Outlet } from "react-router-dom";
import "@/styles/concierge.css";

export function ConciergeLayout() {
  return (
    <div className="concierge-root min-h-[100dvh]">
      <Outlet />
    </div>
  );
}

export default ConciergeLayout;
